<!--
 * @Description: 项目参与人完成任务区间
 * @Date: 2024-01-11 13:52:40
-->
<template>
  <div class="bi-tmpl-detail__right__cmpt">
    <div
      v-if="curItem.tips"
      class="bi-tmpl-detail__right__cmpt__tips"
      style="margin-bottom: 6px"
    >
      {{ curItem.tips }}
    </div>

    <div>
      <span class="bi-tmpl-detail__right__cmpt__title" style="margin-top: 0">
        {{ curItem.title }}
      </span>
    </div>
    <Carousel ref="carouselRef" :itemHeight="200" :itemWidth="420 + 56">
      <div
        style="height: 200px; width: 100%"
        v-for="(item, index) in TYPE_MAPPING"
        :key="index"
        @click="onChange(item.value)"
      >
        <BaseCard style="width: 420px; height: 200px">
          <BaseRadio
            class="bi-tmpl-detail__right__cmpt__radio bi-tmpl-detail__right__cmpt__radio--w"
            :value="item.value"
            :model-value="curItem.value"
          >
            <div
              v-if="item.svg"
              v-html="item.svg"
              style="margin-top: 24px"
            ></div>
            <component
              v-else
              style="margin-top: 20px"
              :is="cmpName(item.value)"
            />
          </BaseRadio>
        </BaseCard>
      </div>
    </Carousel>
  </div>
</template>

<script lang="ts" setup>
import { BaseRadio } from 'xrk-components';
import { BaseCard } from 'xrk-components';
import { useDetailCmpt } from '@V/bi-tmpl/src/hooks';
import { Carousel } from '@/components/base/carousel';
import PcModuleSection from '../../../../../bi-pc-module/pc-module-task/index';
import { commonSVG } from '../../../commonSVG';

const CHILD_KEY = '4_3_1';
const TYPE_MAPPING: Array<{ value: any; index: number; svg?: string }> = [
  ...[1, 2, 3, 4, 5].map(i => {
    return {
      value: 'pc-module-task-' + i,
      index: i
    };
  }),
  {
    svg: commonSVG,
    value: [2, 3, 9, 6, 10, 7].join(','),
    index: 6
  }
];

const cmpName = name => {
  return PcModuleSection.filter(comp => comp.__name === name)[0];
};

const { curItem, onChange } = useDetailCmpt({ childKey: CHILD_KEY });
</script>
<style scoped lang="scss">
::v-deep {
  .xrk-radio__input {
    bottom: -90px !important;
  }
}
</style>
